import { Controller } from "@hotwired/stimulus"

export default class extends Controller {

  static targets = ['input', 'results', 'autocompleteDiv', 'listingCount', 'listingLocation']

  connect() {
    // submit search on enter key press
    document.addEventListener('turbo:load', function() {
      document.querySelectorAll('.search-bar-input').forEach(function(input) {
        input.addEventListener('keypress', function(event) {
          if (event.key === 'Enter') {
            event.preventDefault(); // Prevent default form submission
            document.getElementById('headerSearchForm').dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
          }
        });
      });
    });

    // show/hide placeholder text on search inputs focus/blur
    this.inputTargets.forEach((input, index) => {
      const origInputValue = input.value
      input.addEventListener('focus', event => {
        if (input.value === origInputValue) {
          input.value = ''
        }
      })
      input.addEventListener('blur', event => {
        if (input.value === '') {
          input.value = origInputValue
        }
      })
    });

    // show/hide search input autocomplete spinners
    this.autocompleteDivTargets.forEach((input, index) => {
      let spinner = null;
      input.addEventListener('loadstart', event => {
        if (input.id === 'autocompleteJobDiv') {
          spinner = document.getElementById('jobInputSpinner');
        }
        else if (input.id === 'autocompleteLocationDiv') {
          spinner = document.getElementById('locationInputSpinner');
        }
        if (spinner) {
          spinner.style.display = 'block';
        }
      })
      input.addEventListener('loadend', event => {
        if (input.id === 'autocompleteJobDiv') {
          spinner = document.getElementById('jobInputSpinner');
        }
        else if (input.id === 'autocompleteLocationDiv') {
          spinner = document.getElementById('locationInputSpinner');
        }
        if (spinner) {
          spinner.style.display = 'none';
        }
      })
    });

    // Initialize the selected item
    this.selectedItem = this.element.querySelector('.autocomplete-result');

    // reload page to perform search on browser back button
    this.handlePopstate = this.handlePopstate.bind(this);
    window.addEventListener("popstate", this.handlePopstate);
  }
  disconnect() {
    window.removeEventListener("popstate", this.handlePopstate);
  }

  selectNextItem() {
    if (this.selectedItem) {
      const nextItem = this.selectedItem.nextElementSibling;
      if (nextItem) {
        this.selectItem(nextItem);
      }
    }
  }
  selectPreviousItem() {
    if (this.selectedItem) {
      const previousItem = this.selectedItem.previousElementSibling;
      if (previousItem) {
        this.selectItem(previousItem);
      }
    }
  }
  selectItem(item) {
    if (item) {
      this.selectedItem.classList.remove('highlighted');
      this.selectedItem = item;
      this.selectedItem.classList.add('highlighted');
    }
  }

  // Autocomplete: set focus on search input fields
  setInputFocus(e) {
    e.preventDefault();
    e.stopImmediatePropagation();

    const queryDiv = document.querySelector('#searchBarQuery');
    const locationDiv = document.querySelector('#searchBarLocation');
    queryDiv.style.display = 'none';
    locationDiv.style.display = 'none';

    const searchInput = document.querySelector('#headerSearchField_job');
    const locationInput = document.querySelector('#headerSearchField_location');
    searchInput.style.display = 'block';
    locationInput.style.display = 'block';

    const inputType = e.currentTarget.id === 'searchBarQuery' ? 'query' : 'location'
    if (inputType === 'query') {
      searchInput.focus();
    }
    else if (inputType === 'location') {
      locationInput.focus();
    }

    searchInput.addEventListener("keypress", function(e) {
      var key = e.which || e.keyCode || 0;
      if (key === 13) {
        e.preventDefault();
        e.stopImmediatePropagation();
      }
    });
    locationInput.addEventListener("keypress", function(e) {
      var key = e.which || e.keyCode || 0;
      if (key === 13) {
        e.preventDefault();
        e.stopImmediatePropagation();
      }
    });

    const pr2Css = document.querySelector('.pr-2');
    if (pr2Css) {
      pr2Css.classList.add('flex-grow-1');
    }
    const pr3Css = document.querySelector('.pr-3');
    if (pr3Css) {
      pr3Css.classList.add('flex-grow-1');
    }
    const submitButton = document.querySelector('#jobSearchSubmit');
    if (submitButton) {
      submitButton.style.display = 'block';
    }
  }

  // job search shimmer and spinners
  showShimmer(event) {
    if (event.target.dataset.formId === 'headerSearchForm') {
      $('#job_listings').addClass('shimmer-overlay');
    }
  }
  hideShimmer(event) {
    if (event.target.dataset.formId === 'headerSearchForm') {
      $('#job_listings').removeClass('shimmer-overlay');
    }
  }

  showSpinner(e) {
    if (e.target.getAttribute("data-turbo-frame") == 'job_listings') {
      const loadMoreElement = document.querySelector('#loadMore');
      const loadingElement = document.querySelector('.job-results-loading');
      loadMoreElement.style.display = 'none';
      loadingElement.style.display = 'block';
    }
  }
  hideSpinner() {
    const loadingElement = document.querySelector('.job-results-loading');
    loadingElement.style.display = 'none';
  }

  // renders total results count on SERP from turbo_load_jobs stream
  updateResultsShownText() {
    // Delay to make sure value is in the DOM
    setTimeout(() => {
      let totalResults = document.querySelector('#loadMore').dataset.offset;
      if (totalResults !== undefined && totalResults !== null && totalResults !== "") {
        let resultsCount = document.createTextNode("1 - " + totalResults);
        const listingCountElement = document.getElementById('listing-count');
        // Ensure listingCountElement has a child to replace
        if (listingCountElement.firstChild) {
          listingCountElement.replaceChild(resultsCount, listingCountElement.firstChild);
        } else {
          listingCountElement.appendChild(resultsCount);
        }
      }
      let searchLocation = document.querySelector('#loadMore').dataset.location;
      if (searchLocation !== undefined && searchLocation !== null && searchLocation !== "") {
        let resultsLocation = document.createTextNode(searchLocation);
        const listingLocationElement = document.getElementById('listing-location');

        // Ensure listingLocationElement has a child to replace
        if (listingLocationElement.firstChild) {
          listingLocationElement.replaceChild(resultsLocation, listingLocationElement.firstChild);
        } else {
          listingLocationElement.appendChild(resultsLocation);
        }
      }
    }, 500);
  }

  // sets url structure on response from turbo-frame job search
  removeUrlParams() {
    const url = new URL(window.location.href);
    let paramsToRemove = ['is_user_requested','button','oq','ol'];
    // Remove specified parameters
    paramsToRemove.forEach(param => {
      url.searchParams.delete(param);
    });
    // Push the updated state to browser history with an indicator flag
    window.history.replaceState({ updated: true }, '', url);
  }

  // reload page on browser back button
  handlePopstate(event) {
    if (event.state && event.state.updated) {
      $('#job_listings').addClass('shimmer-overlay');
      window.location.reload();
    }
  }

  // trigger browser geo location confirm prompt
  getBrowserGeoLocation() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        const UpwardGeoLocation = true;
        let url = null;
        if (UpwardGeoLocation) {
          url = ENV['LEAD_FUSION_UW_API_BASE_URL'] + '/jsp/upward/webapp/findLocation.jsp?latitude=' + position.coords.latitude + '&longitude=' + position.coords.longitude;
        }
        else {
          url = 'https://api.bigdatacloud.net/data/reverse-geocode-client?latitude=' + position.coords.latitude + '&longitude=' + position.coords.longitude + '&localityLanguage=en';
        }
        fetch(url).then(response => {
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
          return response.json();
        })
        .then(data => {
          if (data) {
            let city, state, zip;
            if (UpwardGeoLocation) {
              if (data.found) {
                city = data.city ? data.city : '';
                state = data.state ? data.state : '';
                zip = data.zip ? data.zip : '';
              }
            }
            else {
              city = data.locality ? data.locality : (data.city ? data.city : '');
              let stateCode = data.principalSubdivisionCode;
              state = stateCode ? stateCode.replace(/^US-/, "") : '';
              zip = data.postcode;
            }
            let searchLocation = null;
            if(zip){
              if(city && state){
                searchLocation = `${city}, ${state} ${zip}`;
              }
              else{
                searchLocation = `${zip}`;
              }
            }
            // If we don't have zip, but have city and state
            else if (city && state) {
              searchLocation = `${city}, ${state}`;
            }
            // If we have city but no state and zip (should never happen)
            else if(city){
              searchLocation = `${city}`;
            }
            // If we have state but no city and zip
            else if(state){
              searchLocation = `${state}`;
            }
            // If we have neither city, state or zip
            else{
              console.log('Location data not provided');
            }
            if (searchLocation) {
              // update location on page
              const locationInput = document.querySelector('#headerSearchField_location');
              const searchBarLocation = document.querySelector('#searchBarLocation');
              locationInput.value = searchLocation;
              searchBarLocation.textContent = searchLocation;
              // update location in url
              let url = new URL(window.location.href);
              url.searchParams.set('l', searchLocation);
              window.history.replaceState({ updated: true }, '', url.toString());
            }
          } else {
            throw new Error('Failed to parse');
          }
        })
        .catch(e => console.log('There was an error: ' + e.message));
      })
    }
  }
}
